module.exports = __webpack_public_path__ + "static/media/fr.24841de9.svg";